/**
 * Клавіші ролі radiogroup / tablist (UIUX/patterns/keyboard; controls/segmented-control, tabs): ← ↑ — попередній, → ↓ — наступний
 * (по колу), Home — перший, End — останній; інша клавіша — null. Повертає індекс варіанта, на який перейти.
 */
export function rovingKey(key: string, index: number, count: number): number | null {
  if (count <= 0) return null;
  if (key === 'ArrowRight' || key === 'ArrowDown') return (index + 1) % count;
  if (key === 'ArrowLeft' || key === 'ArrowUp') return (index - 1 + count) % count;
  if (key === 'Home') return 0;
  if (key === 'End') return count - 1;
  return null;
}
